import cx from 'classnames'
import Link from 'next/link'
import React from 'react'

import { buildActionAnalyticsAttributes } from '@mondough/analytics-v2'
import { Copy, useCopy } from '@mondough/copy'

import { AuthContext } from '../../providers/AuthProvider'
import monzoLogo from '../../public/images/Monzo.svg'
import { getCDNSrc, userLogout } from '../../utils'
import styles from './Header.module.scss'
import { Button } from '..'

export default function Header() {
  const { isSessionUpgraded } = React.useContext(AuthContext)
  const [displayLogout, setDisplayLogout] = React.useState(false)
  const c = useCopy()

  React.useEffect(() => {
    setDisplayLogout(isSessionUpgraded)
  }, [isSessionUpgraded])

  return (
    <header className={styles.header}>
      <Link
        href="https://monzo.com"
        className={styles.logo}
        {...buildActionAnalyticsAttributes('header-logo')}
      >
        <img
          src={getCDNSrc(monzoLogo)}
          alt={c.string({
            key: 'app_tabs_monzo_me.header.logo.alt',
            message: 'Monzo',
          })}
          className={styles['white-logo']}
        />
      </Link>
      <div className={styles['trailing-content']}>
        <Button
          href="https://monzo.com/sign-up/?utm_source=tabsmonzome&utm_medium=website"
          size="small"
          className={cx([styles['mobile-button']])}
          target="_blank"
          theme="primary"
          rel="noopener noreferrer"
          {...buildActionAnalyticsAttributes('header-free-account')}
        >
          <Copy.Simple
            id="app_tabs_monzo_me.common.cta.get_free_account"
            fallback="Get a free bank account"
          />
        </Button>
        {displayLogout && (
          <Button
            id="log-out"
            onClick={async () => await userLogout(true)}
            size="small"
            theme="tertiary"
            className={cx([styles['desktop-button'], 'desktop-only'])}
            {...buildActionAnalyticsAttributes('header-logout')}
          >
            <Copy.Simple
              id="app_tabs_monzo_me.common.actions.log_out"
              fallback="Log out"
            />
          </Button>
        )}
      </div>
    </header>
  )
}
